export const mockData = (files: File[]) => {
  return {
    dataTransfer: {
      files,
      items: files.map((file: File) => ({
        kind: 'file',
        type: file.type,
        getAsFile: () => file,
      })),
      types: ['Files'],
    },
  }
}

export const getMockFiles = (
  filesAmount = 1,
  extension = 'json',
  type = 'application/json'
): File[] => {
  const fileNames = ['foo', 'bar', 'baz', 'foobar', 'foobaz', 'bazbar']

  return new Array(filesAmount).fill(null).map((_, index) => {
    const name = fileNames[index % fileNames.length]
    const file = new File(['hello world'], `${name}.${extension}`, {
      type,
    })
    return file
  })
}

export const getMockEvent = (eventName: string, files: File[]) => {
  const event = new Event(eventName, { bubbles: true })
  const data = mockData(files)
  Object.assign(event, data)
  return event
}
